module.exports = __webpack_public_path__ + "img/지파이 고소한맛(S).527fe822.jpg";